/* eslint-disable no-undef */
import type { TenantInfo } from './types';

export const cookies = {
  set: (tenant: TenantInfo, cookieName: string) => {
    // Set expiration date to 10 years from now
    const expirationDate = new Date();
    expirationDate.setFullYear(expirationDate.getFullYear() + 10);

    // Use base64 encoding for better efficiency with non-Latin characters
    const jsonString = JSON.stringify(tenant, (_, value) =>
      typeof value === 'string' ? value.normalize('NFC') : value
    );
    const encodedValue = Buffer.from(jsonString, 'utf8').toString('base64');

    document.cookie = `${cookieName}=${encodedValue}; path=/; SameSite=Lax; expires=${expirationDate.toUTCString()}`;
  },

  get: (cookieName: string) => {
    if (typeof window === 'undefined') {
      return undefined;
    }

    const cookies = window.document.cookie.split(';');
    const tenantCookie = cookies.find((cookie) => cookie.trim().startsWith(`${cookieName}=`));
    if (!tenantCookie) return undefined;

    const encodedValue = tenantCookie.split('=')[1];
    try {
      // Decode base64 and parse JSON
      const jsonString = Buffer.from(encodedValue, 'base64').toString('utf8');
      return jsonString;
    } catch (e) {
      return undefined;
    }
  },

  remove: (cookieName: string) => {
    document.cookie = `${cookieName}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
  },
};
